import PinkPlayerDanceMin from "../../../assets/avatars/avatarsDancing/PinkPlayerDanceMin.png"
import YellowPlayerDanceMin from "../../../assets/avatars/avatarsDancing/YellowPlayerDanceMin.png"
import BluePlayerDanceMin from "../../../assets/avatars/avatarsDancing/BluePlayerDanceMin.png"
import GreenPlayerDanceMin from "../../../assets/avatars/avatarsDancing/GreenPlayerDanceMin.png"
import { FC } from "react"

interface ICelebrationAvatar {
    avatarColor: string;
}

const CelebrationAvatar: FC<ICelebrationAvatar> = ({avatarColor}) => {
    
    const setAvatarColor = () => {
        switch(avatarColor){
            case "pink": 
                return PinkPlayerDanceMin;
            case "yellow": 
                return YellowPlayerDanceMin;
            case "blue": 
                return BluePlayerDanceMin;
            case "green": 
                return GreenPlayerDanceMin;
        }
        return "";
    }

    return (
        <div className="full_screen position_absolute">

            <div className="celebration_avatar_wrapper">
                <div className="wrapper_demo_dance">
                    <img className="png_sprint_demo_dance" alt="Dancing avatar" src={setAvatarColor()} />
                </div>
            </div>
        </div>
    )
}

export default CelebrationAvatar;